export const getCookieHelper = (name: string): string | undefined => {
  const value = `; ${document.cookie}`;
  const parts: string[] = value.split(`; ${name}=`) || [];
  if (typeof parts !== typeof undefined && parts.length === 2) {
    return parts?.pop()?.split(";").shift();
  }
};
